module.exports = __webpack_public_path__ + "img/play-circle.550d2992.svg";